import { CircularProgress, ListItemText, useTheme, styled } from '@mui/material'
import { OnboardingChecklistTaskProps } from '../types'
import CheckIcon from 'assets/icons/icon-check-primary.svg?react'
import RoundedIcon from 'features/common/ui/RoundedIcon'
import { MenuItem } from '@carto/meridian-ds/components'

type MenuItemRootProps = { completed?: boolean; loading?: boolean }

const MenuItemRoot = styled(MenuItem, {
  shouldForwardProp: (prop: string) => !['completed', 'loading', 'disabled'].includes(prop)
})<MenuItemRootProps>(({ completed, loading, disabled, theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  height: 'auto',

  '&:hover': {
    backgroundColor: disabled ? 'inherit' : theme.palette.action.hover
  },
  '& .MuiListItemText-root': {
    marginLeft: theme.spacing(1)
  },

  ...(completed && {
    '& svg path': {
      fill: theme.palette.secondary.main
    }
  }),
  ...(loading && {
    pointerEvents: 'none',
    opacity: 0.5
  }),
  ...(disabled && {
    pointerEvents: 'none',
    opacity: 0.4
  })
}))

export function OnboardingChecklistTask({
  icon,
  title,
  completed,
  loading,
  disabled,
  onClick
}: OnboardingChecklistTaskProps) {
  const theme = useTheme()

  return (
    <MenuItemRoot
      completed={completed}
      loading={loading}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      aria-label="onboarding-checklist-task"
      iconColor="default"
    >
      <RoundedIcon
        icon={
          loading ? (
            <CircularProgress color="secondary" size={18} aria-label="onboarding-checklist-task-icon-loading" />
          ) : completed ? (
            <CheckIcon aria-label="onboarding-checklist-task-icon-check" />
          ) : (
            icon
          )
        }
        backgroundColor={completed ? theme.palette.secondary.relatedLight : theme.palette.action.hover}
        iconColor={completed ? theme.palette.secondary.main : undefined}
        size="small"
      />
      <ListItemText>{title}</ListItemText>
    </MenuItemRoot>
  )
}

export default OnboardingChecklistTask
